import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const foundersImg = "/images/fondatori.jpg";

export const AboutFounders = () => (
  <section id="chi-siamo" className="bg-[#080808] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Chi siamo"
        title={
          <>
            Una visione.
            <br />
            Una missione.
          </>
        }
        testid="about-heading"
      />
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <Reveal>
          <div className="relative mx-auto max-w-md overflow-hidden rounded-sm border border-[#C9A45C]/30 lg:max-w-none">
            <img
              src={foundersImg}
              alt="Elio Briotti e Chiara Perrone, fondatori di Fede & Fitness Italia e Tempio Vivo"
              loading="lazy"
              className="h-full w-full object-cover"
            />
            <div
              className="absolute inset-0 bg-gradient-to-t from-[#080808]/60 to-transparent"
              aria-hidden="true"
            />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <h3 className="font-display text-2xl font-semibold text-[#C9A45C] sm:text-3xl">
            Elio Briotti e Chiara Perrone
          </h3>
          <p className="mt-2 text-xs font-bold uppercase tracking-[0.25em] text-[#B8B8B8]">
            Fondatori di Fede &amp; Fitness Italia e Tempio Vivo
          </p>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-[#B8B8B8]">
            <p>
              Abbiamo creato Tempio Vivo perché crediamo che la fede debba
              trasformare la vita quotidiana. Non soltanto le parole. Ma anche
              le decisioni, le abitudini, la disciplina, il corpo e le
              relazioni.
            </p>
            <p>
              Attraverso il Metodo di Coaching Cristiano Tempio Vivo vogliamo
              aiutare uomini e donne a crescere con Dio al centro.
            </p>
            <p>
              Non vogliamo sostituire la tua chiesa o la tua comunità locale.
              Vogliamo offrirti strumenti concreti e uno spazio di crescita
              fondato sui valori cristiani.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
